export class Biller
{
    id: string;
    billername: string;
    rate: string;   
    createdate: string;
}


// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/models/billermodel.ts